// Imports => React
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

let _scrollDirectionDelay = null;

const AcScrollHOC = ({ children }) => {
  const location = useLocation();
  // We use a useRef here, to prevent re-renders
  const previousScrollPosition = useRef(null);

  useEffect(() => {
    const $scroller = document.getElementById('ac-scroller');
    if ($scroller && $scroller.scrollTo) {
      $scroller.scrollTo(0, 0);
      window.scrollTo(0, 0);
    }
  }, [location]);

  const addScrollEventHandler = () => {
    const $scroller = document.getElementById('ac-scroller');

    if ($scroller && $scroller.addEventListener) {
      $scroller.addEventListener(
        'scroll',
        (event) => {
          if (_scrollDirectionDelay) clearTimeout(_scrollDirectionDelay);
          const top = $scroller.scrollTop;
          const diff = top - previousScrollPosition.current;
          let direction = null;
          let delay = 0;

          // detects new state and compares it with the new one
          // we take in consideration:
          // -- velocity (diff between last post and current is bigger than 10)
          // -- min scroll distance (current top should be bigger than 150)
          if (
            top > previousScrollPosition.current &&
                        top >= 150 &&
                        diff >= 10
          ) {
            direction = 'down';
            delay = 150;
          } else {
            direction = 'up';
            delay = 0;
          }

          _scrollDirectionDelay = setTimeout(() => {
            // Store the new position for iteration.
            previousScrollPosition.current = top;

            const scrollDirectionEvent = new CustomEvent(
              'scrollDirectionChanged',
              {
                detail: { direction },
              }
            );
            window.dispatchEvent(scrollDirectionEvent);
          }, delay);
        },
        { passive: true }
      );
    }
  };

  useEffect(() => {
    addScrollEventHandler();
  }, []);

  return children;
};

export default AcScrollHOC;
